import React, { Component } from "react";
import PropTypes from "prop-types";
import { defineMessages, FormattedMessage } from "react-intl";
import { connect } from "react-redux";

import Auth from "../Auth";

import Link from "../../../../../components/Link";
import Callout from "../../../../../components/Callout";
import Form from "../../../../../components/Form";
import Text from "../../../../../components/Form/Input/Text";
import Password from "../../../../../components/Form/Input/Password";

import * as SessionActions from "../../../../../actions/SessionActions";
import history from "../../../../../history";
import { sites } from "../../../../../configPublic";

const messages = defineMessages({
  incorrectLoginData: {
    id: "auth.login.incorrectLoginData",
    defaultMessage: "Incorrect username or password.",
    description: "Incorrect username or password Message"
  },
  throttled: {
    id: "auth.login.throttled",
    defaultMessage: "Too many failed attempts.  Try again later.",
    description: "Too many failed attempts.  Try again later."
  },
  login: {
    id: "auth.login.login",
    defaultMessage: "Login",
    description: "Login Link"
  },
  signup: {
    id: "auth.login.signup",
    defaultMessage: "SIGN UP",
    description: "Sign Up Link"
  },
  forgot: {
    id: "auth.login.forgot",
    defaultMessage: "Forgot your password?",
    description: "Forgot your password Message"
  },
  support: {
    id: "auth.login.support",
    defaultMessage: "Need support?",
    description: "support Message"
  },
  clickHere: {
    id: "auth.login.clickHere",
    defaultMessage: "Click Here",
    description: "Click Here Link"
  },
  emailAddress: {
    id: "auth.login.emailAddress",
    defaultMessage: "Email Address",
    description: "Email Address Label"
  },
  password: {
    id: "auth.login.password",
    defaultMessage: "Password",
    description: "Password Label"
  },
  btn1: {
    id: "auth.login.btn1",
    defaultMessage: "...submitting",
    description: "btn1"
  },
  btn2: {
    id: "auth.login.btn2",
    defaultMessage: "Login",
    description: "btn2"
  }
});

class Login extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired
  };

  static contextTypes = {
    fetch: PropTypes.func.isRequired,
    url: PropTypes.object.isRequired,
    routeParams: PropTypes.object.isRequired,
    query: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired
  };

  constructor(...args) {
    super(...args);
    this.submitHandler = this.submitHandler.bind(this);
    this.state = {
      submitting: false,
      value: {},
      loginError: false
    };
  }

  componentDidMount() {
    const { session } = this.props;
    const { url, routeParams } = this.context;
    if (session.USER_DATA) {
      history.replace(url.getUrl("home", routeParams));
    }
  }

  async submitHandler(e) {
    const { query, routeParams, url } = this.context;
    const { dispatch } = this.props;
    const { siteId } = routeParams;
    this.setState({
      submitting: true,
      value: e.value,
      loginError: false,
      loginErrorType: null
    });
    const resp = await this.context.fetch(`/${siteId}/auth/login`, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        username: e.value.username,
        password: e.value.password
      }),
      credentials: "include"
    });
    // if (resp.status !== 200) throw new Error(resp.statusText);
    let data;
    try {
      data = await resp.json();
    } catch (err) {
      data = false;
    }

    if (resp.status !== 200 || !data || !data.user) {
      this.setState({
        submitting: false,
        loginError: true,
        loginErrorType: resp.status === 429 ? "throttled" : "incorrectLoginData"
      });
    } else {
      dispatch(SessionActions.setMeData(data));
      const redirectUrl =
        query.redirect && query.redirect !== "undefined"
          ? query.redirect
          : url.getUrl("home", routeParams);
      history.push(redirectUrl);
    }
  }

  render() {
    const { url, routeParams, intl } = this.context;
    const { siteId } = routeParams;
    const { loginError, loginErrorType } = this.state;

    return (
      <Auth>
        <div className="Auth__container">
          {/* <div className="flex-center auth__links">
            <Link
              className="link link--medium"
              to={url.getUrl("auth-index", routeParams)}
              activeClassName="is-active"
            >
              <FormattedMessage {...messages.login} />
            </Link>
            <Link
              className="link link--medium"
              to={url.getUrl("auth-register", routeParams)}
              activeClassName="is-active"
            >
              <FormattedMessage {...messages.signup} />
            </Link>
          </div> */}

          <div className="Auth__subtitle">beauty erp</div>

          <div className="Auth__title">
            <FormattedMessage {...messages.login} />
          </div>

          {loginError && (
            <Callout size="small" type="alert">
              <FormattedMessage {...messages[loginErrorType]} />
            </Callout>
          )}

          <Form
            className="Auth__form"
            title={this.props.title}
            onValidSubmit={this.submitHandler}
            submitButtonLabel={
              this.state.submitting
                ? intl.formatMessage(messages.btn1)
                : intl.formatMessage(messages.btn2)
            }
            value={this.state.value}
            isSubmitting={this.state.submitting}
          >
            <Text
              label={intl.formatMessage(messages.emailAddress)}
              helpText=""
              errorText=""
              name="username"
              required
            />
            <Password
              label={intl.formatMessage(messages.password)}
              helpText=""
              errorText=""
              name="password"
              required
            />

            <div className="Auth__forgotContainer">
              <Link
                className="Auth__forgot"
                to={url.getUrl("auth-forgot", routeParams)}
              >
                <FormattedMessage {...messages.forgot} />
              </Link>
            </div>
          </Form>

          {/* <p className="auth__help">
            <br />
            <FormattedMessage {...messages.support} />{" "}
            <a
              className="auth__link"
              href={sites[siteId].contact.support}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FormattedMessage {...messages.clickHere} />
            </a>
          </p> */}
        </div>
      </Auth>
    );
  }
}

export default connect(state => ({ session: state.session }))(Login);



// WEBPACK FOOTER //
// ./src/routes/client/site/auth/default/Login.js